module.exports = {
    aor: {
        action: {
            delete: 'מחיקה',
            show: 'עוד',
            list: 'רשימה',
            save: 'שמירה',
            create: 'חדש',
            edit: 'עריכה',
            cancel: 'ביטול',
            refresh: 'רענון',
            add_filter: 'הוספת פילטר',
            remove_filter: 'הסרת פילטר',
        },
        boolean: {
            true: 'כן',
            false: 'לא',
        },
        page: {
            list: 'רשימת %{name}',
            edit: '%{name} #%{id}',
            show: '%{name} #%{id}',
            create: 'חדש %{name}',
            delete: 'מחיקה %{name} #%{id}',
             dashboard: 'דף הבית',
        },
        input: {
            image: {
                upload_several: 'Déposez les fichiers à uploader, ou cliquez pour en sélectionner.',
                upload_single: 'Déposez le fichiers à uploader, ou cliquez pour le sélectionner.',
            },
        },
        message: {
            yes: 'כן',
            no: 'לא',
            are_you_sure: 'האם אתה בטוח ?',
            about: 'אודות',
        },
        navigation: {
            page_out_of_boundaries: 'La page %{page} est en dehors des limites',
            page_out_from_end: 'Fin de la pagination',
            page_out_from_begin: 'La page doit être supérieure à 1',
            page_range_info: '%{offsetBegin}-%{offsetEnd} מתוך %{total}',
            next: 'הבא',
            prev: 'הקודם',
            no_results:'אין תוצאות'
        },
        auth: {
            username: 'שם משתמש',
            password: 'ססמא',
            sign_in: 'התחברות',
            sign_in_error: 'שגיאת התחברות',
            logout: 'יציאה',
        },
        notification: {
            updated: 'רשומה עודכנה',
            created: 'רשומה נוצרה',
            deleted: 'רשומה נמחקה',
            item_doesnt_exist: 'לא קיים',
        },
        validation: {
            required: 'חובה',
            email: 'אימייל',
        },
    },
};



// WEBPACK FOOTER //
// ./src/aor-language-hebrew/index.js